var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box",class:{'is-home':_vm.isHome}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("@2021-2025 上海风物风清企业管理合伙企业(有限合伙) ")]),_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("沪ICP备2021008312号-1")])])])
}]

export { render, staticRenderFns }